import {FormControl, TextField} from '@material-ui/core';
import {InputProps} from '@material-ui/core/Input';
import {InputBaseComponentProps} from '@material-ui/core/InputBase';
import classnames from 'classnames';
import React, {useState} from 'react';
import ErrorPopover, {Errors, ErrorsUnion} from 'Shared/components/ErrorPopover';
import MenuStateProvider from 'Shared/components/MenuStateProvider';
import {withEventValue} from 'Shared/utilities/WithEventValue';

type ValidatableTextFieldProps<TErrors extends ErrorsUnion> = {
  id?: string;
  errors: TErrors;
  showErrors?: (errors: TErrors) => boolean;
  className?: string;
  textInputClassName?: string;
  label: string;
  value: string;
  disabled?: boolean;
  placeholder?: string;
  inputProps?: InputBaseComponentProps;
  InputProps?: InputProps;
  onChange: (value: string) => void;
  onBlur?: () => void;
  multiline?: boolean;
};

const ValidatableTextField = <TErrors extends ErrorsUnion>(props: ValidatableTextFieldProps<TErrors>) => {
  const [hasBeenBlurred, setHasBeenBlurred] = useState(false);
  const showErrors =
    (props.showErrors ? props.showErrors(props.errors) : props.errors.value.length > 0) && hasBeenBlurred;

  return (
    <MenuStateProvider>
      {({close, open, anchor}) => (
        <FormControl error={showErrors} fullWidth className={classnames(props.className, props.textInputClassName)}>
          <TextField
            multiline={props.multiline}
            InputProps={props.InputProps}
            disabled={props.disabled}
            variant="outlined"
            placeholder={props.placeholder}
            id={props.id}
            autoComplete="off"
            label={props.label}
            fullWidth
            inputProps={props.inputProps}
            error={showErrors}
            value={props.value}
            onFocus={event => {
              open(event.currentTarget);
            }}
            onChange={withEventValue(props.onChange)}
            onBlur={() => {
              if (props.onBlur) {
                props.onBlur();
              }
              setHasBeenBlurred(true);
              close();
            }}
          />
          <ErrorPopover
            open={Errors.match(props.errors, {
              requirements: () => Boolean(anchor),
              standardErrors: errors => showErrors && errors.value.length > 0 && Boolean(anchor),
            })}
            anchor={anchor}
            errors={props.errors}
          />
        </FormControl>
      )}
    </MenuStateProvider>
  );
};

export default ValidatableTextField;
